export const Types = {
  // Busca uma Atividade
  GET_REQUEST: 'attachment/GET_REQUEST',
  GET_SUCCESS: 'attachment/GET_SUCCESS',
  GET_FAILURE: 'attachment/GET_FAILURE',

  // reseta o estado
  RESET: 'attachment/RESET',
};

export const initialState = {
  // Busca uma Atividade
  attachment: {},
  attachmentLoading: false,
  attachmentError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
   // Busca uma Atividade
    case Types.GET_REQUEST:
      return { ...state, attachmentLoading: true };
    case Types.GET_SUCCESS:
      return {
        ...state,
        attachment: action.payload.data,
        attachmentLoading: false,
        attachmentError: null,
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        attachmentLoading: false,
        attachmentError: action.payload,
      };
    case Types.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export const Creators = {
  // Busca uma Atividade
  getAttachmentRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),
  getAttachmentSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: data,
  }),
  getAttachmentFailure: error => ({
    type: Types.GET_FAILURE,
    payload: error,
  }),
  reset: () => ({
    type: Types.RESET,
  }),
};